<ng-container *ngIf="showPanelWrapper">
  <ng-container *ngTemplateOutlet="panelWrapper"></ng-container>
</ng-container>
<ng-container *ngIf="!showPanelWrapper && showTableWrapper">
  <ng-container *ngTemplateOutlet="tableWrapper"></ng-container>
</ng-container>
<ng-container *ngIf="!showPanelWrapper && !showTableWrapper">
  <ng-container *ngTemplateOutlet="table"></ng-container>
</ng-container>

<ng-template #panelWrapper>
  <app-bui-section
    [fullHeight]="height === ItemsTableHeightTypeEnum.FULL"
    [isExpanded]="true"
    [title]="objectDefinition | objectName">
    <ng-container *ngTemplateOutlet="tableWrapper"></ng-container>
  </app-bui-section>
</ng-template>

<ng-container
  [appBreakpointObserver]="mqBelowNarrow"
  (observedBreakpointChanged)="screenSizeChanged($event)">
  <ng-template #tableWrapper>
    <app-layout-content-data-wrapper
      #layoutContentDataWrapper
      [title]="objectDefinition | objectName"
      [height]="ItemsTableHeightTypeEnum.FULL"
      [isDetailsTable]="detailTable">
      <ng-container *ngIf="!screenSizeSmall">
        <ng-container *ngIf="!detailTable">
          <app-bui-button-icon
            *ngIf="itemOptions?.tableDropdownActions?.length"
            [iconName]="'menu-down'"
            [comboStyle]="'outline'"
            [matMenuTriggerFor]="tableActionsMoreMenu">
          </app-bui-button-icon>
          <ng-container *ngFor="let item of itemOptions?.actions">
            <ng-container *ngIf="!item.overRecord && !item.inTable">
              <app-bui-button-label
                *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, item.permission], !!item.permission]"
                [comboStyle]="item?.style || 'outline'"
                [disabled]="item.disabled"
                (clickEvent)="actionClick(item)">
                {{ item | actionTranslate }}
              </app-bui-button-label>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template appLayoutContentDataWrapperHeaderActions>
          <app-bui-search *ngIf="!!itemOptions && itemOptions?.searchInput"
            [formControl]="filterFormControl">
          </app-bui-search>
          <app-bui-button-icon *ngIf="!itemOptions || itemOptions?.showRefresh"
            [iconName]="'refresh'"
            [comboStyle]="'settings'"
            [borderStyle]="'dark'"
            (clickEvent)="refresh()">
          </app-bui-button-icon>
          <app-bui-button-icon *ngIf="!itemOptions || itemOptions?.showSettings"
            [iconName]="'settings-table-cog'"
            [iconType]="BUI_ICON_TYPE_CUSTOM"
            [comboStyle]="'settings'"
            [borderStyle]="'dark'"
            (clickEvent)="openSettingsDialog()">
          </app-bui-button-icon>
          <app-bui-button-icon *ngIf="!itemOptions || itemOptions?.showPalette"
            [comboStyle]="'settings'"
            [iconName]="'palette'"
            [borderStyle]="'dark'"
            [contentColor]="'dark'"
            (clickEvent)="openFormatDialog()">
          </app-bui-button-icon>
          <app-bui-button-icon *ngIf="!itemOptions || itemOptions?.showSum"
            [matTooltip]="'REPORT_BUTTONS.SUM' | translate"
            [matTooltipShowDelay]="100"
            [comboStyle]="'settings'"
            [iconName]="'sigma'"
            [borderStyle]="'dark'"
            [contentColor]="'dark'"
            (clickEvent)="openSummariesDialog()">
          </app-bui-button-icon>

          <app-bui-button-icon
            *ngIf="!preventDelete && isEditMode && (!itemOptions || itemOptions?.showSelectionDelete)"
            [iconName]="'delete'"
            [disabled]="!hasSelectedRows"
            [comboStyle]="'settings'"
            [borderStyle]="'dark'"
            (clickEvent)="deleteSelectedItems()">
          </app-bui-button-icon>
          <ng-container *ngIf="itemOptions?.showFilters">
            <app-master-data-records-filters-button
              [filters]="filters || objectDefinition.filters"
              [compositeFilter]="compositeFilter"
              [openFiltersByDefault]="openFiltersByDefault"
              (filterItemChangedEvent)="onFilterItemChanged($event)"
              (applyFiltersEvent)="onApplyFilters($event)">
            </app-master-data-records-filters-button>
          </ng-container>

          <ng-container *ngIf="detailTable">
            <app-bui-button-icon
              *ngIf="itemOptions?.tableDropdownActions?.length"
              [iconName]="'menu-down'"
              [comboStyle]="'outline'"
              [matMenuTriggerFor]="tableActionsMoreMenu">
            </app-bui-button-icon>
            <ng-container *ngFor="let item of itemOptions?.actions">
              <ng-container *ngIf="!item.overRecord && !item.inTable">
                <app-bui-button-label
                  *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, item.permission], !!item.permission]"
                  [comboStyle]="item?.style || 'outline'"
                  [disabled]="item.disabled"
                  (clickEvent)="actionClick(item)">
                  {{ item | actionTranslate }}
                </app-bui-button-label>
              </ng-container>
            </ng-container>
            <app-bui-button-icon
              *ngIf="(viewActions && !preventAdd && hasAddPermission) || (isEditMode && !preventAdd && hasAddPermission)"
              [comboStyle]="'fill-gradient-1'"
              [contentColor]="'light'"
              [iconName]="'plus'"
              (click)="addNewClick()">
            </app-bui-button-icon>
          </ng-container>

        </ng-template>
      </ng-container>

      <ng-container *ngIf="screenSizeSmall">
      <!-- missing manu-down and add on small screen when listView -->
        <ng-container *ngIf="!detailTable">
          <app-bui-button-icon
            *ngIf="itemOptions?.tableDropdownActions?.length"
            [iconName]="'menu-down'"
            [comboStyle]="'outline'"
            [matMenuTriggerFor]="tableActionsMoreMenu">
          </app-bui-button-icon>
          <ng-container *ngFor="let item of itemOptions?.actions">
            <ng-container *ngIf="!item.overRecord && !item.inTable">
              <ng-container *ngIf="item.action !== ItemActionEnum.Add">
                <app-bui-button-label
                  *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, item.permission], !!item.permission]"
                  [comboStyle]="item?.style || 'outline'"
                  [disabled]="item.disabled"
                  (clickEvent)="actionClick(item)">
                  {{ item | actionTranslate }}
                </app-bui-button-label>
              </ng-container>
              <ng-container *ngIf="item.action === ItemActionEnum.Add">
                <app-bui-button-icon
                  *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, item.permission], !!item.permission]"
                  [comboStyle]="'fill-gradient-1'"
                  [disabled]="item.disabled"
                  (clickEvent)="actionClick(item)"
                  [iconName]="'plus'">
                </app-bui-button-icon>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template appLayoutContentDataWrapperHeaderActions>
          <div class="c-items-table__header-action-search">
            <app-bui-search *ngIf="!!itemOptions && itemOptions?.searchInput"
              [formControl]="filterFormControl">
            </app-bui-search>
          </div>
          <app-bui-button-icon
            [borderStyle]="'dark'"
            [iconName]="'dots-horizontal'"
            [comboStyle]="'settings'"
            [contentColor]="'dark'"
            [matMenuTriggerFor]="menuItemOverflowedButtonsPanel">
          </app-bui-button-icon>
          <ng-container *ngIf="itemOptions?.showFilters">
            <app-master-data-records-filters-button
              [filters]="filters || objectDefinition.filters"
              [compositeFilter]="compositeFilter"
              [openFiltersByDefault]="openFiltersByDefault"
              (filterItemChangedEvent)="onFilterItemChanged($event)"
              (applyFiltersEvent)="onApplyFilters($event)">
            </app-master-data-records-filters-button>
          </ng-container>
          <app-bui-button-icon
            *ngIf="detailTable && itemOptions?.tableDropdownActions?.length"
            [iconName]="'menu-down'"
            [comboStyle]="'outline'"
            [matMenuTriggerFor]="tableActionsMoreMenu">
          </app-bui-button-icon>
          <ng-container *ngIf="detailTable && itemOptions?.actions.length">
            <app-bui-button-icon
              [borderStyle]="'intense'"
              [iconName]="'menu-down'"
              [comboStyle]="'outline'"
              [matMenuTriggerFor]="menuItemPanel">
            </app-bui-button-icon>
          </ng-container>
          <app-bui-button-icon
            *ngIf="isEditMode && !preventAdd && hasAddPermission"
            [comboStyle]="'fill-gradient-1'"
            [contentColor]="'light'"
            [iconName]="'plus'"
            (click)="addNewClick()">
          </app-bui-button-icon>
        </ng-template>

      </ng-container>

      <mat-menu #tableActionsMoreMenu="matMenu">
        <ng-container *ngFor="let item of itemOptions?.tableDropdownActions">
          <button
            *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, item.permission], !!item.permission]"
            mat-menu-item
            [attr.aria-label]="item.action"
            [disabled]="item.disabled"
            (click)="actionClick(item)">
            {{ item | actionTranslate }}
          </button>
        </ng-container>
      </mat-menu>

      <ng-template appLayoutContentDataWrapperBody>
        <ng-container *ngIf="showTabsWrapper">
          <ng-container *ngTemplateOutlet="tabsWrapper"></ng-container>
        </ng-container>
        <ng-container *ngIf="!showTabsWrapper">
          <ng-container *ngTemplateOutlet="table"></ng-container>
        </ng-container>
      </ng-template>
    </app-layout-content-data-wrapper>
  </ng-template>
</ng-container>

<mat-menu #menuItemPanel="matMenu">
  <ng-container *ngFor="let item of itemOptions?.actions">
    <button
      mat-menu-item>
      {{ item | actionTranslate }}
    </button>
  </ng-container>
</mat-menu>

<mat-menu #menuItemOverflowedButtonsPanel="matMenu">
  <div class="c-items-table__overflowed-buttons-menu">
    <button
      mat-menu-item
      *ngIf="!itemOptions || itemOptions?.showRefresh"
      (click)="refresh()">
      {{ 'REPORT_BUTTONS.RELOAD' | translate }}
    </button>
    <button
      mat-menu-item
      *ngIf="!itemOptions || itemOptions?.showSettings"
      (click)="openSettingsDialog()">
      {{ 'FIELD_SETTINGS_DIALOG.TITLE' | translate }}
    </button>
    <button
      mat-menu-item
      *ngIf="!preventDelete && isEditMode"
      (click)="deleteSelectedItems()">
      {{ 'COMMON.DELETE_SELECTED' | translate }}
    </button>
  </div>
</mat-menu>

<ng-template #tabsWrapper>
  <app-bui-tabs
    [selectedIndex]="0"
    (tabChangedEvent)="tabChanged($event)">
    <ng-container *ngFor="let tab of tabs?.slice(0, 50)">
      <ng-template appBuiTab [label]="tab.label">
        <ng-container *ngTemplateOutlet="table"></ng-container>
      </ng-template>
    </ng-container>
  </app-bui-tabs>
</ng-template>

<ng-template #table>
  <ng-container *ngIf="!screenSizeSmall">
    <ng-container *ngIf="compositeFilter?.showChips">
      <ng-container *ngIf="itemOptions?.showFilters">
        <app-active-filters
          [fields]="filters || objectDefinition.filters"
          [compositeFilter]="compositeFilter"
          (applyFiltersEvent)="onApplyFilters($event)"
          (isExpandedEvent)="setActiveFiltersHeight($event)">
        </app-active-filters>
      </ng-container>
    </ng-container>

    <div class="c-beyond-table c-items-table"
      #dataGridWrapperDiv
      [ngClass]="[
        height ? 'c-items-table--height-' + height : '',
        compositeFilter?.showChips&&!detailTable ? 'c-items-table--active-filters-height-' + activeFiltersHeight : '',
      ]">
      <ng-container *ngIf="draggedColumn">
        <div #hideDropzoneItem class="action-columns-dropzone-container" [ngStyle]="dropZoneStyle">
          <app-bui-icon class="hide-icon" [name]="'eye-off'"></app-bui-icon>
        </div>
      </ng-container>

      <dx-data-grid
        [dataSource]="dataSource"
        [showBorders]="true"
        [remoteOperations]="false"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [rowDragging]="{allowReordering: true}"
        [columnAutoWidth]="false"
        [columnMinWidth]="15"
        [columns]="columns"
        [width]="'100%'"
        [hoverStateEnabled]="true"
        [focusedRowEnabled]="isEditMode"
        [autoNavigateToFocusedRow]="true"
        [columnResizingMode]="'widget'"
        [noDataText]="'COMMON.NO_DATA' | translate"
        (onEditingStart)="onEditingStart($event)"
        (onRowUpdated)="onEditingEnd($event)"
        (onInitialized)="onInitialized($event)"
        (onRowRemoved)="onRowRemoved($event)"
        (onRowRemoving)="onRowRemoving($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowPrepared)="onRowPrepared($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onOptionChanged)="onOptionChanged($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onContentReady)="onContentReady($event)"
        (mouseup)="mouseUpEvent($event)"
        (contextmenu)="disableRightClick($event)"
        (onEditorPreparing)="onEditorPreparing($event)"
        (onKeyDown)="onKeyDown($event)">
        <dxo-scrolling
          *ngIf="virtualScroll"
          showScrollbar="always"
          mode="virtual">
        </dxo-scrolling>
        <dxo-filter-row *ngIf="showDevExtremeFilterRow" [visible]="filterRowVisible"></dxo-filter-row>
        <dxo-header-filter [visible]="true" [allowSearch]="true" [width]="200" [height]="250"></dxo-header-filter>
        <dxo-selection
          [mode]="multiSelection ? 'multiple' : 'single'"
          [showCheckBoxesMode]="showSelection ? 'always' : 'never'">
        </dxo-selection>
        <dxo-editing
          [mode]="'cell'"
          [allowAdding]="false"
          [allowDeleting]="viewActions || (!preventDelete && isEditMode)"
          [allowUpdating]="inlineEditing && isEditMode"
          [confirmDelete]="false"
          [useIcons]="true"
          [startEditAction]="'click'"
          [selectTextOnEditStart]="true"
          [newRowPosition]="'last'">
        </dxo-editing>
        <dxo-keyboard-navigation
          [editOnKeyPress]="editOnkeyPress"
          [enterKeyAction]="enterKeyAction"
          [enterKeyDirection]="enterKeyDirection">
        </dxo-keyboard-navigation>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-sorting [mode]="multiSort ? 'single': 'multiple'"></dxo-sorting>
        <dxo-summary *ngIf="items?.length"
          [calculateCustomSummary]="calculateSelectedRow"
          [recalculateWhileEditing]="true">
          <ng-container *ngFor="let summary of summaryFilters">
            <dxi-total-item
              [name]="summary.columnName"
              [summaryType]="'custom'"
              [showInColumn]="summary.columnName"
              [valueFormat]="summary.summaryFormat"
              [displayFormat]="displayFormat(summary.summaryType)">
            </dxi-total-item>
            <dxi-group-item
              [name]="summary.columnName"
              [summaryType]="'custom'"
              [showInColumn]="summary.columnName"
              [valueFormat]="summary.summaryFormat"
              [displayFormat]="displayFormat(summary.summaryType)">
            </dxi-group-item>
          </ng-container>
        </dxo-summary>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-grouping></dxo-grouping>
        <dxo-group-panel [visible]="groupPanelVisible"></dxo-group-panel>
        <dxo-row-dragging
          [allowReordering]="allowReordering && isEditMode"
          [onReorder]="onRowReorder"
          [showDragIcons]="true">
        </dxo-row-dragging>
      </dx-data-grid>

      <app-custom-pagination
        *ngIf="isPaginationEnabled"
        [pagination]="pagination"
        (paginationChangedEvent)="paginationChangedEvent.emit($event)">
      </app-custom-pagination>
    </div>
  </ng-container>

  <ng-container *ngIf="screenSizeSmall">
    <app-master-data-cards
      [ngClass]="!detailTable ? 'c-items-table__item-cards-wrapper' : ''"
      [objectDefinition]="objectDefinition"
      [dataSource]="this.filteredItems"
      (itemActionEvent)="onItemsCardClick($event)"
      [isItemsView]="detailTable"
      [isEditMode]="false">
    </app-master-data-cards>
    <app-custom-pagination *ngIf="!detailTable"
      [pagination]="pagination"
      (paginationChangedEvent)="paginationChangedEvent.emit($event)">
    </app-custom-pagination >
  </ng-container>
</ng-template>

<ng-container>
  <ng-template cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="itemsTableLookupColumnHelper.triggerOrigin"
    (backdropClick)="itemsTableLookupColumnHelper.isDropdownOpen=false"
    [cdkConnectedOverlayOpen]="itemsTableLookupColumnHelper.isDropdownOpen"
    [cdkConnectedOverlayPositions]="[itemsTableLookupColumnHelper.connectedPositions]"
    [cdkConnectedOverlayWidth]="itemsTableLookupColumnHelper.triggerRect?.width!"
    (overlayOutsideClick)="itemsTableLookupColumnHelper.closeDropdown()">
    <div class="dropdownList-wrapper">
      <div class="dropdownList" #dropdownList role="listbox">
        <table-lookup-dropdown-item
          *ngFor="let item of itemsTableLookupColumnHelper.autocompleteList; index as i"
          [item]="item"
          (click)="itemsTableLookupColumnHelper.onClicked(item, $event)"
          (mousedown)="itemsTableLookupColumnHelper.onDropdownElemClick(item, $event)"
          [ngClass]="(itemsTableLookupColumnHelper.selectedDropdownIndex === i) ? 'activeItem' : ''">
          {{ item | recordDisplayValue: itemsTableLookupColumnHelper.lookupField.lookupObject }}
        </table-lookup-dropdown-item>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-container>
  <ng-template #columnFixPopup let-column>
    <div class="c-items-table-column-menu-popup">
      <ng-container *ngFor="let option of itemsTableHeaderPopupService.columnFixOptions">
        <button
          mat-button
          (click)="fixColumn(column, option.value)">
          {{option.label | itemsHeaderOptionPipe}}
        </button>
      </ng-container>
    </div>
  </ng-template>
</ng-container>

<ng-template #columnDebugPopup let-debug>
  <app-column-debug
    [showTrigger]="false"
    [path]="debug?.path"
    [columnName]="debug?.columnName">
  </app-column-debug>
</ng-template>

<ng-template #actionsDropdown let-item>
  <div class="actions-dropdown-wrapper">
    <div class="dx-list">
      <ng-container *ngFor="let actionItem of item | beyondTableActions:itemOptions">
        <ng-container *ngIf="actionItem.inTable">
          <ng-container
            *appHasPermission="[objectDefinition?.name, [PermissionActionEnum.FULL, actionItem.permission], !!actionItem.permission]">
            <div class="dx-list-item"
              (click)="handleAction(actionItem.action, item)">
              {{ actionItem | actionTranslate }}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
